<template>
    <div>
        <rkm-sidebar-list-group
            v-for="item in items"
            v-bind:key="item.id"
            class="sidebar-list-group"
        >
            <rkm-sidebar-list-group-item
                :active="`/${$route.path.split('/')[1]}/${$route.path.split('/')[2]}` == item.link"
                :icon="item.icone && item.icone.split('/')"
                :title="item.nome"
                :to="item.link"
                class="sidebar-list-group-item"
            />

            <rkm-sidebar-list
                v-if="item.items"
                class="sidebar-list"
                sub-group
            >
                <sidebar-item :items="item.items" />
            </rkm-sidebar-list>
        </rkm-sidebar-list-group>
    </div>
</template>

<script>
export default {
    name: 'SidebarItem',
    props: {
        items: { type: Array },
    },
}
</script>

<style lang="scss" scoped>
$primary: #007bff;

.sidebar-list {
    transition: 0.02s 0.02s;
    visibility: hidden;
}
.sidebar-list-group:hover > .sidebar-list-group-item {
    color: darken($primary, 10%) !important;
}
.sidebar-list-group:hover > .sidebar-list {
    visibility: visible;
}
</style>